/* eslint-disable @typescript-eslint/no-explicit-any */

import { HydratableComponentFactoryOptions, HydratableComponentFactory } from '~/services/hydrater/types'

export interface Hydratable {
  el: HTMLElement
  component: any
  mount(): BaseHydratable
  unmount(): BaseHydratable
}
/**
 * Base Adapter class for wrapping hydratable components onto DOM elements
 *
 * - Provides a standardised mounting/unmounting pattern
 * - Provides references to the component instance and the DOM element
 */
export default abstract class BaseHydratable implements Hydratable {
  /**
   * The element that the component will be mounted on
   */
  public el: HTMLElement
  /**
   * The component instance
   */
  public component: any

  protected constructor(
    componentFactory: HydratableComponentFactory,
    el: HTMLElement,
    factoryOptions: HydratableComponentFactoryOptions,
  ) {
    this.component = componentFactory(el, factoryOptions)
    this.el = el
  }
  /**
   * Called when the component should be mounted, returns this to allow chaining
   */
  abstract mount(): BaseHydratable;
  /**
   * Called when the component should be unmounted, returns this to allow chaining
   */
  abstract unmount(): BaseHydratable;
}
